module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (7).ddadb878.svg";